import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from 'context/AppContext';
import { IAppInit } from 'types';
import axiosInstance from 'utils/axiosInstance';

window.onmessage = (event) => {
  if (!event?.data?.publicKey) {
    return;
  }

  axiosInstance.interceptors.request.use((config) => {
    config.headers['Authorization'] = `${event.data.publicKey}`;
    return config;
  });

  axiosInstance.interceptors.request.use((config) => {
    config.baseURL = `${
      event.data.mode === 'TEST'
        ? 'https://collections.uat.ceviant.co/paymentgateway'
        : 'https://collections.ceviant.co/paymentgateway'
    }`;
    return config;
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    //<React.StrictMode>
      <AppProvider>
        <App {...(event.data as IAppInit)} />
      </AppProvider>
    //</React.StrictMode>
  );
};
